import React from "react";
import ReactDOM from "react-dom/client";
import Application from "./Application";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
);

reportWebVitals();
